import { matchRoutes } from 'react-router-config';
import routeList from '../../routeList';

export default function isFullNavigation(url) {
  const usePatientsUiProvider = global.CLIENT_ENV.ENABLE_PATIENTS_UI_PROVIDER_PAGE;
  const selectedRoutes = matchRoutes(routeList, url);
  const fullNavRoutes = usePatientsUiProvider
    ? ['NotFoundPage']
    : ['NotFoundPage', 'MainProviderPage'];

  return selectedRoutes.length !== 0 && fullNavRoutes.includes(selectedRoutes[0].route.name);
}
